import { useInView } from "react-intersection-observer";
import { useUpdateEffect } from "react-use";
import { useRecoilValue, useSetRecoilState } from "recoil";

import intersectIndicesState from "./intersectIndicesState";
import visibleIndicesSelector from "./visibleIndicesSelector";

export const useIntersectionIndicies = (index: number) => {
  const setIntersectIndices = useSetRecoilState(intersectIndicesState);
  // list of indexes of the blocks that should be visible
  const visibleIndices = useRecoilValue(visibleIndicesSelector);

  const { ref, inView } = useInView({
    threshold: 0,
  });

  // add element's index to the intersected blocks list
  useUpdateEffect(() => {
    setIntersectIndices((prevState) =>
      inView ? [...prevState, index] : prevState.filter((i) => i !== index)
    );
  }, [inView]);

  return { blockRef: ref, visibleIndices };
};
